import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";

const swatchMaterialGroups = {
  actions,
  getters,
  mutations,
  namespaced: true,
  state: {
    groups: {}
  }
};

export default swatchMaterialGroups;
